<template>
  <div class="zzzd_MDContainer">
    <div class="zzzd_MDWrapper">
      <div class="zzzd_header">
        <span>需求管理</span>
      </div>
      <div class="zzzd_content">
        <div class="zzzd_top">
          <div class="from-left">
            <div class="from-item">
              <span class="span-left">需求ID：</span>
              <el-input v-model="form.No"></el-input>
            </div>
            <div class="from-item">
              <span class="span-left">响应状态</span>
              <el-select v-model="form.diagnosisType" placeholder="全部">
                <el-option label="未推送" value="wts"></el-option>
                <el-option label="已推送" value="yts"></el-option>
                <el-option label="已跟进" value="ygj"></el-option>
                <el-option label="已成单" value="ycd"></el-option>
                <el-option label="已关闭" value="ygb"></el-option>
              </el-select>
            </div>
            <div class="from-item">
              <span class="span-left">联系电话：</span>
              <el-input v-model="form.phone"></el-input>
            </div>
            <div class="from-item">
              <span class="span-left">公司名称：</span>
              <el-input v-model="form.name"></el-input>
            </div>
            <div class="from-item">
              <span class="span-left">更新时间：</span>
              <el-date-picker
                v-model="form.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeDate"
                style="width:400px"
                :clearable = 'false'
              ></el-date-picker>
            </div>
            <div class="from-item" style="float:right">
              <el-button type="primary" @click="search(1)">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </div>
        </div>
        <div class="zzzd_bottom">
          <el-table :data="baseData" style="width: 100%" v-loading="loading">
            <el-table-column prop="needNo" label="需求ID" width="200"></el-table-column>
            <el-table-column prop="typeName" label="需求类型" width="200"></el-table-column>
            <el-table-column prop="publishName" label="公司名称" width="200"></el-table-column>
            <el-table-column prop="publishMobile" label="联系电话" width="110"></el-table-column>
            <el-table-column prop="statusName" label="需求状态" width="100"></el-table-column>
            <el-table-column prop="updated_at" label="更新时间"></el-table-column>
            <el-table-column label="操作" width="70">
              <template slot-scope="scope">
                <el-button @click="checkDetail(scope.row)" type="text" size="small">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="float:right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage2"
              :page-size="5"
              layout=" prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { opNeedList } from "@/api/zzzd_onNeed.js";
import { logout } from "@/api/user";
import { getCookie, removeCookie } from "@/utils/getToken.js";
export default {
  data() {
    return {
      baseData: [],
      form: {
        No: "",
        phone: "",
        diagnosisType: "",
        date: "",
        time: "",
        type: "",
        name: "",
      },
      currentPage2: 1,
      total: 0,
      dataArr: [],
      loading:true
    };
  },
  methods: {
    goToHome() {
      this.$router.push("/diagnose/ECommerce/settledType");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search(val);
    },
    // 查看详情
    checkDetail(row) {
      this.$router.push({
        path: "/diagnose/personal/demandDetail",
        query: { needNo: row.needNo },
      });
    },
    // 查询
    search(page) {
      let params = {
        needNo: this.form.No,
        // diagnosisTypeName:this.form.diagnosisType,
        publishName: this.form.name,
        publishMobile: this.form.phone,
        stdate: this.dataArr[0], //起
        endate: this.dataArr[1], //止
        pageNumber: page,
        pageSize: 5,
        status: this.form.diagnosisType,
      };
      this.currentPage2 = page;
      opNeedList(params).then((res) => {
        if (res.status == 0) {
          this.loading = false
          this.baseData = res.data.rows;
          let data = res.data.rows;
          this.total = res.data.count;
          //格式化时间
          data.forEach((item) => {
            item.updated_at = moment(item.updated_at).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            if (item.typeName == null && item.notes != null) {
              item.typeName = item.notes;
            } else if (item.typeName == null && item.notes == null) {
              item.typeName = "其他";
            }
          });
        }else if(res.status == -99){
          this.$message('登录超时，请重新登录')
          this.logout()
        }
      });
    },
    // 重置
    resetForm() {
      this.form.No = "";
      this.form.phone = "";
      this.form.diagnosisType = "";
      this.form.date = "";
      this.form.time = "";
      this.form.type = "";
      this.form.name = "";
      this.dataArr = [];
      this.search(1);
    },
    changeDate(e) {
      if (e) {
        e.forEach((item) => {
          this.dataArr.push(moment(item).format("YYYY-MM-DD HH:mm:ss"));
        });
      }
    },
    logout() {
      logout(getCookie("userpin")).then((res) => {
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          // this.$message({
          //   message: "已退出登录！",
          //   type: "success",
          // });
          this.$router.push("/diagnose");
        } else {
          this.$message.error("退出登录失败！");
        }
      });
    },
  },
  mounted() {
    this.search(1);
  },
};
</script>

<style lang="scss" >
.zzzd_MDContainer {
  background: #ebecef;
  width: 100%;
  // height: 100%;
  border-top: 1px solid #ebecef;
  .zzzd_MDWrapper {
    // width: 1190px;
    // background: #fff;
    // height: 90%;
    // margin: 29px auto 0;
    overflow: hidden;
    .zzzd_header {
      width: 100%;
      height: 50px;
      background: #fff;
      font-size: 18px;
      padding-left: 20px;
      line-height: 50px;
      font-weight: 600;
    }
    .zzzd_content {
      padding: 20px;
      .zzzd_top {
        padding: 20px 20px 0;
        background: #fff;
        margin-bottom: 20px;
        .zzzd_title {
          font-size: 16px;
          font-weight: 600;
          line-height: 50px;
        }
        .from-left {
          flex: 8;
          display: flex;
          flex-wrap: wrap;
          .from-item {
            display: flex;
            margin-right: 30px;
            margin-bottom: 24px;
            .span-left {
              display: flex;
              justify-content: center;
              align-items: center;
              min-width: 70px;
              color: rgba(47, 47, 47, 1);
            }
            .el-input > input,
            .el-input__inner {
              width: 200px;
              height: 36px;
              background: rgba(255, 255, 255, 1);
              border-radius: 0;
              border: 1px solid rgba(225, 225, 225, 1);
            }
          }
        }
      }
      .zzzd_bottom {
        padding: 0 20px 20px;
        background: #fff;
        .zzzd_title {
          font-size: 16px;
          font-weight: 600;
          line-height: 50px;
        }
        .el-table {
          margin-bottom: 30px;
        }
        .line {
          width: 100%;
          height: 1px;
          background: #eee;
        }
      }
    }
  }
}
</style>